import React from 'react'
import PropTypes from 'prop-types'
import { FormText } from 'reactstrap'

const TextareaAdapter = (
  {
    input,
    meta,
    invalid = meta => meta.touched && meta.invalid,
    valid = () => false,
    ...rest
  }
) => <FormText { ...input } { ...rest } invalid={ invalid(meta) } valid={ valid(meta) }/>

TextareaAdapter.propTypes = {
  invalid: PropTypes.func,
  valid:   PropTypes.func,
}

export default TextareaAdapter